<div class="row">
    <div class="col-24">
        <p class="required">All fields are required, unless marked as optional.</p>
    </div>
</div>
<div class="row">
    <div class="col-24">
        <h2 class="head2-small">Section 7: Send the enrollment application to your client</h2>
    </div>
</div>

<div class="row">
    <div class="col-16">
        <p class="bold-font">Selected Plan: {{enDetail.PLANNAME}}</p>
        <p>Please review the following information, and click the button at the bottom of the page to send the enrollment application to your client.</p>
    </div>
</div>

<div class="row">
    <div class="col-24">
        <div class="partition">
            <h2 class="head2-small">Terms of Enrollment</h2>
        </div>
    </div>
</div>
<div class="row">
    <div class="col-16">
        <div class="bottom-20">
            <p><strong>By completing this enrollment application, I agree to the following:</strong></p>
            <p>{{orgName}} PDP is a Medicare drug plan and has a contract with the Federal government. I understand that this prescription drug coverage is in addition to my coverage under Medicare; therefore, I will need to keep my Medicare Part A or Part B coverage. It is my responsibility to inform {{orgName}} of any prescription drug coverage that I have or may get in the future. I can only be in one Medicare Prescription Drug Plan at a time – if I am currently in a Medicare Prescription Drug Plan, my enrollment in {{orgName}} will end that enrollment. Enrollment in this plan is generally for the entire year. Once I enroll, I may leave this plan or make changes if an enrollment period is available, generally during the Annual Enrollment Period (October 15 – December 7), unless I qualify for certain special circumstances.</p>
            <p>{{orgName}} serves a specific service area. If I move out of the area that {{orgName}} serves, I need to notify the plan so I can disenroll and find a new plan in my new area. I understand that I must use network pharmacies, except in an emergency when I cannot reasonably use {{orgName}} network pharmacies. Once I am a member of {{orgName}}, I have the right to appeal plan decisions about payment or services if I disagree. I will read the Evidence of Coverage document from {{orgName}} when I get it to know which rules I must follow to get coverage.</p>
            <p>I understand that if I leave this plan and don’t have or get other Medicare prescription drug coverage or creditable prescription drug coverage (as good as Medicare’s), I may have to pay a late enrollment penalty in addition to my premium for Medicare prescription drug coverage in the future.</p>
            <p>I understand that if I am getting assistance from a sales agent, broker, or other individual employed by or contracted with {{orgName}}, he or she may be paid based on my enrollment in {{orgName}}.</p>
            <p>Counseling services may be available in my state to provide advice concerning Medicare supplement insurance or other Medicare Advantage or Prescription Drug Plan options, medical assistance through the state Medicaid program, and the Medicare Savings Program.</p>
        </div>
    </div>
</div>
<div class="row">
    <div class="col-24">
        <h2 class="head2-small">Release of Information</h2>
    </div>
</div>
<div class="row">
    <div class="col-16">
        <div class="bottom-20">
            <p>By joining this Medicare Prescription Drug Plan, I acknowledge that {{orgName}} PDP will release my information to Medicare and other plans as is necessary for treatment, payment and health care operations. I also acknowledge that {{orgName}} will release my information, including my prescription drug event data, to Medicare, who may release it for research and other purposes which follow all applicable federal statutes and regulations. The information on this enrollment form is correct to the best of my knowledge. I understand that if I intentionally provide false information on this form, I will be disenrolled from the plan.</p>
            <p><b>I understand that my signature (or the signature of the person authorized to act on my behalf under state law where I live) on this application means that I have read and understand the contents of this application.</b> </p>
            <p>If signed by an authorized individual (as described above), this signature certifies that:</p>
            <p>1) This person is authorized under state law to complete this enrollment and<p>
            <p>2) Documentation of this authority is available upon request by Medicare.</p>
        </div>
    </div>
</div>
<div class="row">
    <div class="col-8">
        <div class="input-wrapper">
            <ValidatedTextField [label]="'Beneficiary\'s Signature'"
                                [text]=""
                                [validators]="[]"
                                [disabled]="disabled">
            </ValidatedTextField>
            <!--(onValueChange)="enDetail.beneficiaryInfo.firstName = $event">-->
        </div>
    </div>
    <div class="col-8">
        <div class="input-wrapper">
            <ValidatedDateTextField id="date-picker-field"
                                    [date]="enDetail.BENEFICIARYDATE"
                                    [label]="'Beneficiary\'s Date'"
                                    [disabled]="disabled"
                                    [validators]="[validatedDate, notBlankValidator]"
                                    (onDateChange)="enDetail.BENEFICIARYDATE = $event">

            </ValidatedDateTextField>
        </div>
    </div>
</div>
<div class="row">
    <div class="col-16">
        <div class="bottom-20">
            <ValidatedRadioButtonGroup [label]="'Does the Applicant have a legal guardian that is authorized to speak on his/her behalf?(Note: The Authorized Representative is NOT the Insurance Agent it is a person who has the power of attorney for the Applicant.)'"
                                       [options]="rblAuthorizedRep"
                                       [selectedValue]="enDetail.AUTHREPIND"
                                       (onValueChange)="rblAuthorizedRepClick($event)"
                                       [radioGroupName]="'rblAuthorizedRep'"
                                       [disabled]="disabled">
            </ValidatedRadioButtonGroup>
        </div>
    </div>
</div>
<div *ngIf="isAuthRep">
    <div class="row">
        <div class="col-8">
            <div class="input-wrapper">
                <ValidatedTextField [label]="'Name of authorized rep'"
                                    [text]="enDetail.AUTHREPNAME"
                                    (onValueChange)="enDetail.AUTHREPNAME = $event"
                                    [validators]="[notBlankValidator]">
                </ValidatedTextField>
            </div>
        </div>
        <div class="col-8">
            <div class="input-wrapper">
                <ValidatedTextField [label]="'Phone Number of authorized rep'"
                                    [text]="enDetail.AUTHREPPHONE"
                                    (onValueChange)="enDetail.AUTHREPPHONE = $event"
                                    [validators]="[numericTextFieldValidator,lengthValidator]">
                </ValidatedTextField>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-4">
            <div class="input-wrapper wide">
                <ValidatedDropDown [label]="'Relationship to applicant'"
                                   [disabled]="'false'"
                                   [selectedValue]="enDetail.AUTHREPREL"
                                   (onValueChange)="enDetail.AUTHREPREL =$event"
                                   [options]="rblRelation">
                </ValidatedDropDown>
            </div>
        </div>
        <div class="col-8">
            <div class="input-wrapper">
                <ValidatedTextField [label]="'Addresss of authorized rep'"
                                    [text]="enDetail.AUTHREPADD1"
                                    (onValueChange)="enDetail.AUTHREPADD1 = $event"
                                    [validators]="[notBlankValidator]">
                </ValidatedTextField>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-4">
            <div class="input-wrapper">
                <ValidatedTextField [label]="'City'"
                                    [text]="enDetail.AUTHREPCITY"
                                    (onValueChange)="enDetail.AUTHREPCITY = $event"
                                    [validators]="[notBlankValidator]">
                </ValidatedTextField>
            </div>
        </div>
        <div class="col-5">
            <div class="input-wrapper wide">
                <ValidatedDropDown [selectedValue]="state"
                                   [label]="'State'"
                                   [disabled]="'false'"
                                   (onValueChange)="enDetail.AUTHREPST  = $event"
                                   [options]="states"
                                   (blur)="onBlur()">
                </ValidatedDropDown>
            </div>
        </div>
        <div class="col-3">
            <div class="input-wrapper">
                <ValidatedTextField [label]="'Zip'"
                                    [text]="enDetail.AUTHREPZIP"
                                    (onValueChange)="enDetail.AUTHREPZIP = $event"
                                    [validators]="[notBlankValidator]">
                </ValidatedTextField>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-24">
            <div class="bottom-20">
                <ValidatedRadioButtonGroup [label]="'Mail Copy of Materials to Authorized Representative'"
                                           [options]="rblMailCopy"
                                           [selectedValue]="enDetail.AUTHREPCOPYIND"
                                           (onValueChange)="enDetail.AUTHREPCOPYIND =$event"
                                           [radioGroupName]="'rblMailCopy'">
                </ValidatedRadioButtonGroup>
            </div>

        </div>
    </div>
</div>
<!--<div class="row">-->
    <indvrep [enrollmentindvrepViewModel]="enDetail"></indvrep>
<!--</div>-->

<fieldset>
    <legend>Agent Information</legend>
    <div class="row">
        <div class="col-8">
            <div class="input-wrapper">

                <ValidatedTextField [label]="'Agent Name'"
                                    [text]="enDetail.AGENTNAME"
                                    [validators]="[notBlankValidator]"
                                    [disabled]="!disabled || statusInProg"
                                    (onValueChange)="enDetail.AGENTNAME = $event">
                </ValidatedTextField>
            </div>
        </div>
        <div class="col-8">
            <div class="input-wrapper">
                <ValidatedTextField [label]="'Agent Signature '"
                                    [text]="enDetail.AgentSignature"
                                    [validators]="[notBlankValidator]"
                                    [disabled]="!disabled"
                                    (onValueChange)="enDetail.AgentSignature = $event">
                </ValidatedTextField>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-16">
            <div class="bottom-20">
                <ValidatedRadioButtonGroup [label]="'SCOPE OF APPOINTMENT (You must check one).'"
                                           [options]="rblAppointmentRep"
                                           [selectedValue]="enDetail.SOA"
                                           (onValueChange)="enDetail.SOA = $event"
                                           [disabled]="!disabled"
                                           [radioGroupName]="'rblAppointmentRep'">
                </ValidatedRadioButtonGroup>
            </div>
        </div>
    </div>

    <div class="row">
        <div class="col-16">
            <p class="bold-font">Please provide the email address of the prospective beneficiary</p>
        </div>
    </div>
    <div class="row">
        <div class="col-8">
            <div class="input-wrapper">
                <ValidatedTextField class="field"
                                    [label]="'Email'"
                                    id="email"
                                    [text]="enDetail.APPEMAIL"
                                    (onValueChange)="enDetail.APPEMAIL = $event"
                                    [validators]="[notBlankValidator, emailValidator]">
                </ValidatedTextField>
            </div>
        </div>
    </div>
    <div *ngIf="hideAgree">
        <div class="row">
            <div class="col-16">
                <p>This email address was provided to me by the prospect and was not rented, purchased or obtained through any type of directory. I have spoken with the prospect, explained the {{orgName}} Prescription Drug Plans and the prospect has requested a {{orgName}} Electronic Enrollment Application. </p>
            </div>
        </div>
        <div class="row">
            <div class="col-16">
                <div class="mrg-10">
                    <ValidatedCheckbox [id]="'checkConfirmationCheck'"
                                       [label]="'I agree'"
                                       [checked]="enDetail.BGCHECK"
                                       [disabled]="false"
                                       (onValueChange)="valueChanged($event)">
                    </ValidatedCheckbox>
                </div>
            </div>
        </div>
    </div>
</fieldset>
